import { Controller } from '@hotwired/stimulus';
import lottie from 'lottie-web';

export default class extends Controller {
  static targets = ['animation'];

  connect() {
    const animationPath = this.data.get('path');
    const playOnLoad = this.data.get('playOnLoad') === 'true';
    if (animationPath && playOnLoad) { this.loadAnimation(animationPath); }
  }

  loadAnimation(path) {
    this.currentAnimation = lottie.loadAnimation({
      container: this.animationTarget,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: path
    });
  }

  disconnect() {
    this.#destroyAnimation();
  }

  #destroyAnimation() {
    if (this.currentAnimation) {
      this.currentAnimation.destroy();
    }
  }
}
